var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import theme, { mediaQueries } from '../../../Theme';
import BarSaleView from '../../components/BarSale';
import { BarCheckout } from '../../../components/BarCheckout';
import { Button, DatePicker, FieldType, Hairline, Scroll, Text, } from '../../../elements';
import { toDate } from '../../../helpers/Format';
import { T } from '../../../helpers/i18n';
import Theme from '../../../Theme';
import { Modal } from '../../../components';
import Input from '../../../elements/Input';
import SaleExtra from '../../../components/SaleExtra';
import SaleC from '../../components/SaleC';
import Payments from '../../components/Payments';
import cxs from 'cxs/component';
import Dataweb from '../../../components/Dataweb';
import { filterHoursFromDay, twoDigits } from '../../../helpers/Utils';
import { inject, observer } from 'mobx-react';
import HoursSelect from '../../../components/HoursSelect';
import DiscountView from '../../../components/DiscountView';
import { textBorded } from '../../components/KeyTouchable';
import { TypeDiscount } from '../../DiscountReasons/IDiscount';
import { SectionSelect } from '../../components/SectionSelect';
import IdaVuelta from '../../../components/IdaVuelta';
import AvailableRerserved from '../../../elements/AvailableReserved';
let StretchesDetailView = class StretchesDetailView extends Component {
    componentDidMount() {
        // @ts-ignore
        if (!this.props.stretch ||
            this.props.stretch.disabled_at ||
            this.props.stretch.disableVirtual) {
            return;
        }
        this.props.tempSaleTicket.setMinimun(this.props.stretch);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this.props.stretch) {
            return React.createElement("div", null, 'Servicio no existe');
        }
        // @ts-ignore
        if (!this.props.stretch ||
            this.props.stretch.disabled_at ||
            this.props.stretch.disableVirtual) {
            return React.createElement(Text, { big: true }, 'servicio no disponible en este momento');
        }
        const { loading, stretch, dateBooking, ticketCheckins, valitedNow, disableCheckout, disablePrintLast, printPrice, discount, tempSaleTicket, sale, tieneDescuento, descuentoAplicado, visible, fechaAtrasada, message, result, afiliatesOptions, discountReasonsOptions, datePickerVisible, hoursFiltered, lineTotal, quantity, visibleExtras, height, saleExtra, paddingBloque, busy, quantityExtras, lineTotalExtras, visiblePayments, visibleDataweb, disabledDate, boardingPass, disableboardingPass, disableValitedNow, onHandleKeyMinusExtras, onHandleKeyPlusExtras, enablePaymentCredit, errorTotal, onHandleCheckbox, onHandleCheckOut, onHandleName, onToggleToModal, onHandleKeyMinus, onHandleKeyPlus, onHandleClose, onHandleCloseFechaAtrasada, onHandleAfiliateDiscountReasonChange, onHandleInputDiscount, onHandleDate, onHandleClickExtra, onHandleClickPayments, onHandleInputMethod, ohHandleAllMoneyClick, onCloseModalPayments, onHandleChangeDataweb, onHandleVisibleDataweb, onHandleChangeHours, onPressIdaVuelta, toggleOriginDestination, errorAforo, afiliateName } = this.props;
        const CONST_HEIGHT = stretch.tramoHora && stretch.horasIda.length > 0 ? 7.2 : 6.2;
        const blocksIdaVuelta = stretch.vuelta ? 2 : 0;
        const numberBlocks = stretch.tramoHora && stretch.horasIda.length > 0
            ? Math.floor(stretch.horasIda.length / 5) + blocksIdaVuelta
            : 0 + blocksIdaVuelta;
        const heightCapacity = stretch.capacity &&
            stretch.capacity > 0 &&
            stretch.tramoHora &&
            stretch.horasIda.length > 0
            ? 30
            : 0;
        /*const heightScroll =
          theme.common.devices.desktopHeight -
          heightCapacity -
          (CONST_HEIGHT + numberBlocks) * theme.common.size.bar +
          'px'
    */
        // const heightScroll = `calc(100% - ${theme.common.size.bar*5}px)`
        const heightScroll = '100%';
        const errorOriginDestination = stretch.vuelta &&
            (((_a = tempSaleTicket.originDestination) === null || _a === void 0 ? void 0 : _a.origin) === null ||
                ((_b = tempSaleTicket.originDestination) === null || _b === void 0 ? void 0 : _b.destination) === null);
        // const errorOriginDestination = stretch.vuelta? tempSaleTicket.originDestination.origin === null || tempSaleTicket.originDestination.destination === null : false
        return (React.createElement(WrapperContainer, null,
            React.createElement(BarSaleView, { args: [stretch.operationLine.name, '->', stretch.name], ticketCheckins: ticketCheckins, handleResetCount: () => { }, afiliateName: this.props.afiliateName }),
            stretch.capacity && stretch.tramoHora && (React.createElement(AvailableRerserved, { stretch: stretch })),
            React.createElement(BarCheckout, { loading: loading, tempSaleTicket: tempSaleTicket, disableboardingPass: disableboardingPass, disableValitedNow: disableValitedNow, valitedNow: valitedNow, boardingPass: boardingPass, disableCheckout: disableCheckout || errorOriginDestination || errorAforo, disablePrintLast: disablePrintLast, printPrice: printPrice, handleCheckbox: onHandleCheckbox, 
                /*handleValitedNow={this.handleValitedNow}*/
                handleCheckOut: onHandleCheckOut, handleName: onHandleName, scanView: true }),
            React.createElement(WrapperDate, { style: {
                    borderRadius: 5,
                }, onClick: onToggleToModal }, `${T('dateBook')}: ${toDate(dateBooking)} ${tempSaleTicket.tramoHora
                ? tempSaleTicket.timeIda
                    ? ` ${twoDigits((_c = tempSaleTicket.timeIda) === null || _c === void 0 ? void 0 : _c.hours)}:${twoDigits((_d = tempSaleTicket.timeIda) === null || _d === void 0 ? void 0 : _d.minutes)}`
                    : ''
                : ''} ${tempSaleTicket.stretch.tramoHora && !tempSaleTicket.timeIda
                ? T('noHourSelected')
                : ' '}`),
            stretch && stretch.tramoHora && (React.createElement(HoursSelect, { lista: tempSaleTicket.stretch.horasIda, listaEnabled: filterHoursFromDay(tempSaleTicket.stretch.horasIda, tempSaleTicket.stretch.disabledDays, tempSaleTicket.datebook), itemSelected: (_e = tempSaleTicket.timeIda) === null || _e === void 0 ? void 0 : _e.id, onChange: onHandleChangeHours })),
            disabledDate && (React.createElement("div", null,
                React.createElement(Text, { center: true, color: Theme.color.primary }, T('disabledDate')))),
            React.createElement("div", { style: {
                    height: theme.size.hairline,
                    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                } }),
            stretch.vuelta && (React.createElement(IdaVuelta, { value: tempSaleTicket.saleVuelta, toggled: tempSaleTicket.stretch.origin !==
                    this.props.store.tempTicketStore.tempSaleTicket.originDestination
                        .origin, disabled: tempSaleTicket.lines.length > 0 || errorOriginDestination, origin: tempSaleTicket.originDestination.origin
                    ? (_f = tempSaleTicket.originDestination.origin) === null || _f === void 0 ? void 0 : _f.toUpperCase() : '', destination: tempSaleTicket.originDestination.destination
                    ? (_g = tempSaleTicket.originDestination.destination) === null || _g === void 0 ? void 0 : _g.toUpperCase() : '', onPress: onPressIdaVuelta, onPressToggle: toggleOriginDestination })),
            React.createElement(WrapperScroll, { height: heightScroll },
                sale.map((item, index, lista) => (React.createElement(SaleC, { key: item.stretchPrice.passengerCategory.name, index: index, lista: lista, item: item, height: height, paddingBloque: paddingBloque, busy: busy, moneyName: stretch.primaryMoney.alphabeticCode, handleKeyMinus: onHandleKeyMinus, quantity: quantity, handleKeyPlus: onHandleKeyPlus, lineTotal: lineTotal, includedExtras: stretch.includedExtras, categoryId: item.stretchPrice.passengerCategory.id }))),
                React.createElement(Hairline, { horizontal: true }),
                errorOriginDestination && (React.createElement(Text, { primary: true, center: true, big: true }, `Falta en servicio ida y vuelta el/los campo/s
              ${tempSaleTicket.originDestination.origin === null
                    ? T('origin')
                    : ''}
              ${tempSaleTicket.originDestination.destination === null
                    ? T('destination')
                    : ''}`)),
                React.createElement(Hairline, { horizontal: true }),
                React.createElement(Button, { onClick: onHandleClickExtra }, T('extras')),
                React.createElement(Hairline, { horizontal: true }),
                React.createElement("div", { style: {
                        margin: '10px',
                    } },
                    React.createElement(SaleExtra, { saleExtra: saleExtra, visibleExtras: visibleExtras, height: height, paddingBloque: paddingBloque, busy: busy, moneyName: stretch.primaryMoney.alphabeticCode, quantityExtras: quantityExtras, lineTotalExtras: lineTotalExtras, handleKeyMinusExtras: onHandleKeyMinusExtras, handleKeyPlusExtras: onHandleKeyPlusExtras })),
                afiliatesOptions && React.createElement(SectionSelect, { name: this.props.store.users.user.afiliate ? 'afiliate' : 'afiliateOptional', column: 'afiliate', values: afiliatesOptions, selectedValue: afiliatesOptions[0], handleOnChange: (name, value, column) => {
                        onHandleAfiliateDiscountReasonChange('afiliate', name, value, column);
                    } }),
                (boardingPass || tempSaleTicket.afiliate) && (React.createElement(Input, { hidden: !boardingPass, type: FieldType.Text, label: 'número de reserva externa', name: 'crossBookingNumber', onChange: (e) => {
                        tempSaleTicket.setCrossBookingNumber(e.target.value);
                    } })),
                React.createElement(Hairline, { horizontal: true }),
                React.createElement("div", { style: {
                        margin: '20px 5px',
                    } },
                    React.createElement(Payments, { moneyName: tempSaleTicket.getStretch().primaryMoney.alphabeticCode, errorTotal: errorTotal, enablePaymentCredit: enablePaymentCredit, tempSale: tempSaleTicket, afiliateSelected: !!tempSaleTicket.afiliate, handleInputMethod: onHandleInputMethod, handleAllMoneyClick: ohHandleAllMoneyClick })),
                React.createElement(Hairline, { horizontal: true }),
                discountReasonsOptions && discountReasonsOptions.length > 1 && (React.createElement(SectionSelect, { name: 'discountReasonOptional', column: 'discountReason', values: discountReasonsOptions, selectedValue: discountReasonsOptions[0], handleOnChange: (name, value, column) => {
                        onHandleAfiliateDiscountReasonChange('discountReason', name, value, column);
                    } })),
                React.createElement(DiscountView, { height: height, tempSale: tempSaleTicket, colorTextDiscount: theme.color.primary, colorTextTotalDiscount: theme.color.primary, moneyName: stretch.primaryMoney.alphabeticCode, options: Object.entries(TypeDiscount).map((item) => ({
                        name: T(item[1]),
                        value: item[1],
                    })), typeDiscount: tempSaleTicket.typeDiscount, busy: busy, textBorded: textBorded, errorTotal: errorTotal, onChangeSelect: (value) => {
                        tempSaleTicket.setTypeDiscount(value);
                    }, onHandleInputDiscount: onHandleInputDiscount }),
                React.createElement(Hairline, { horizontal: true }),
                React.createElement(Button, { onClick: onHandleVisibleDataweb }, T('dataClient')),
                visibleDataweb && (React.createElement(WrapperContact, null,
                    React.createElement(Dataweb, { dataweb: tempSaleTicket.dataContact, onHandleChange: onHandleChangeDataweb })))),
            datePickerVisible && stretch.type !== 'event' && (React.createElement(Modal, { title: T('dateBook') },
                React.createElement(DatePicker, { name: 'dateBook', 
                    /*date={date}*/
                    date: dateBooking, onChange: onHandleDate, stretch: stretch, calendarAvailable: true, disabledDays: stretch.disabledDays })))));
    }
};
StretchesDetailView = __decorate([
    inject('store'),
    observer
], StretchesDetailView);
export default StretchesDetailView;
const WrapperContainer = cxs('div')({
    backgroundColor: 'white',
    marginBottom: `${theme.common.size.bar * 2}px`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    [mediaQueries.mobile]: {
        height: '100%',
    },
});
const WrapperScroll = cxs(Scroll)(({ height }) => ({
    [mediaQueries.mobile]: {
        overflowY: 'scroll',
    },
    [mediaQueries.desktop]: {
        height,
        overflowY: 'auto',
    },
    [mediaQueries.md]: {
        height: height,
        overflowY: 'auto',
    },
}));
const WrapperContact = cxs(Scroll)({
    marginLeft: '25px',
    marginRight: '25px',
    minHeight: '10%',
    [mediaQueries.mobile]: {
        minHeight: '300px',
    },
});
const WrapperDate = cxs('div')({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'black',
    padding: '8px',
    margin: '5px 10px',
    ':hover': {
        borderColor: theme.color.primary,
        color: theme.color.primary,
        borderWidth: '2px',
        padding: '7px',
        cursor: 'pointer',
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesDetailView.tsx
// module id = 367
// module chunks = 0